/* eslint-env browser, jquery */
/* global WOW */
import debugT from 'debug';
import container from 'modules/section-content';
import rg from 'modules/npm-component/require-global';
import domify from 'domify';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import request from 'superagent';
import splash from './jobs-page.pug';
import culture from './culture.json';
import metadata from './metadata.json';

const debug = debugT('auth0:jobs');

let pollTimer = 0;
let numberOfLogins = 0;

export default function register() {
  page('/jobs', loadJobs, render, loadScripts, updateContext);
  page('/jobs/:department', loadJobs, render, loadScripts, opening, updateContext);
  page('/jobs/:department/:opening', loadJobs, render, loadScripts, updateContext);
  page.exit('/jobs/(.*)?', unpoll);
}

function render(ctx, next) {
  const alreadyrender = $('.jobs-page #job-openings').length;

  $('html').removeClass('header-dark');

  if (alreadyrender) {
    ctx.rendered = true;
  }

  const view = domify(
    splash({
      jobs: ctx.jobs,
      culture
    })
  );

  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view })
  };
  container.render(renderOptions);

  next();
}

function loadJobs(ctx, next) {
  ctx.jobs = [];
  request.get('/jobs.json').end((err, res) => {
    if (err) return next();
    if (!res || !res.body || !res.body.length) return next();
    return (ctx.jobs = res.body), next();
  });
}

function opening(ctx, next) {
  $('nav.menu-bar a').removeClass('active');
  $(`[href="/jobs/${ctx.params.opening}"]`).addClass('active');
  $('.tab-content .tab-pane').removeClass('active');
  $(`[id="${ctx.params.opening}"]`).addClass('active');

  if (ctx.params.opening) {
    const title = $(`[id="${ctx.params.opening}"] h3`).text();

    setTitle(title);
    setDescription(title);
  }

  if (ctx.rendered) {
    $(window).scrollTop($('#job-openings').offset().top);
  }

  next();
}

function setTitle(text) {
  document.title = `Jobs - ${text}`;
}

function setDescription(text) {
  const $description = $('meta[name=description]');
  $description.attr(
    'content',
    `${text}. We are always looking for talented people to join our team.`
  );
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/jobs/resources/owl-ffaa3c82ad.carousel.min.js', '$.fn.owlCarousel', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/jobs/resources/jquery-78b16ff121.accordion.js', '$.fn.accordion', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/jobs/resources/jquery-0850ae304b.mixitup.min.js', '$.MixItUp', done);
  });

  batch.push(done => {
    rg('//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js', 'bootstrap', done);
  });

  batch.end(next);
}

function updateContext(ctx, next) {
  $('#owl-banner').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    nav: true,
    mouseDrag: false,
    lazyLoad: true
  });

  $('#owl-who').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    nav: false,
    mouseDrag: false,
    lazyLoad: true
  });

  $('#owl-culture').owlCarousel({
    center: true,
    loop: true,
    lazyLoad: true,
    responsiveRefreshRate: 10,
    mouseDrag: false,
    nav: true,
    dots: false,
    navText: '',
    items: 2
  });

  if (!$('#job-openings').data('initialized')) {
    $('html.jobs-page').on('click', '.jobs__item.mix', function(e) {
      $('#job-openings').data('initialized', true);

      if ($(e.target).parents('.modal').length || $(e.target).hasClass('modal')) {
        return;
      }

      const $link = $(this).find('a.jobs-item__more');

      return page($link.attr('href'));
    });
  }

  function updateNumberOfLogins(callback) {
    $.ajax({
      url: '/jobs/counters',
      cache: false
    }).done(response => {
      numberOfLogins = response.logins;
      $('.js-join-stats').toggleClass('join-hidden', false);
      $('.js-join-stats').toggleClass('animated fadeInDown', true);

      $('#tokens').text(numberOfLogins.toLocaleString());

      if (typeof callback === 'function') callback();
    });
  }

  function poll() {
    debug("polling in %sms for new counter of jwt's issued", 1000);
    pollTimer = setTimeout(updateNumberOfLogins, 1000, poll);
  }

  updateNumberOfLogins(poll);

  new WOW().init();

  const loc = location.pathname.split('/').pop();

  switch (loc) {
    case 'jobs':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'customer-success':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.customer-success'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'security':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.security'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'engineer':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.engineer'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'h-r':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.h-r'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'marketing':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.marketing'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'design':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.design'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 'r-d':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.r-d'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    case 's-m':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.s-m'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;

    default:
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        callbacks: {
          onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              !ctx.params.opening && history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState(
                { path: 'jobs' },
                '',
                `/jobs/${state.activeFilter.split('.').pop()}`
              );
            }
          }
        }
      });
      break;
  }

  $('.modal').each(function() {
    const id = $(this).attr('id');
    if (id === loc) {
      $(`#${id}`).modal('show');
    }
  });

  $('.modal').on('hidden.bs.modal', () => {
    if ($('span.filter.active').data('filter').split('.').pop() === 'all') {
      history.replaceState({ path: 'jobs' }, '', '/jobs');
    } else {
      history.replaceState(
        { path: 'jobs' },
        '',
        `/jobs/${$('span.filter.active').data('filter').split('.').pop()}`
      );
    }
  });

  $('.modal').on('show.bs.modal', function() {
    const title = $(this).find('.modal-title').text();
    setTitle(title);
    setDescription(title);
  });

  $('.accordion')
    .accordion({
      transitionSpeed: 400,
      singleOpen: false
    })
    .off('accordion.open')
    .on('accordion.open', event => {
      const path = $(event.target).data('path');
      if (ctx.pathname !== path) page.replace(path);
    });

  if (ctx.params.opening) {
    $(`#${ctx.params.opening}.accordion:not(.open) [data-control]`).trigger('accordion.toggle');
  }

  // Scroll to href ID
  $('a[data="scroll-to"]').click(function() {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      let target = $(this.hash);
      target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
      if (target.length) {
        $('html,body').animate(
          {
            scrollTop: target.offset().top
          },
          1000
        );
        return false;
      }
    }
  });

  next();
}

function unpoll(ctx, next) {
  debug("clearing jwt' counter poll timer");
  clearTimeout(pollTimer);
  const modalCloseButton = document.querySelector('.close');
  if (modalCloseButton) modalCloseButton.click();
  debug('leaving page');
  next();
}



// WEBPACK FOOTER //
// ./src/pages/jobs/jobs.js